document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('size-button') && !event.target.disabled) {
      event.preventDefault();
      event.stopPropagation();
      
      const button = event.target;
      const sizeSelector = button.closest('.card-size-selector');
      const productId = sizeSelector.dataset.productId;
      const selectedSize = button.dataset.size;
      const variantId = button.dataset.variantId;
      
      const allButtons = sizeSelector.querySelectorAll('.size-button');
      allButtons.forEach(btn => btn.classList.remove('size-button--selected'));
      button.classList.add('size-button--selected');
      
      addToCart(variantId, productId);
    }
  });
});

function addToCart(variantId, productId) {
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    showCartSuccess();
    
    if (window.cartDrawer) {
      window.cartDrawer.refresh();
    }
    
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { variantId: variantId, productId: productId }
    }));
  })
  .catch(error => {
    showCartError();
  });
}

function showCartSuccess() {
  const successMsg = document.createElement('div');
  successMsg.innerHTML = '✓ Added to cart!';
  successMsg.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #28a745;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 9999;
    font-weight: 600;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  `;
  
  document.body.appendChild(successMsg);
  
  setTimeout(() => {
    successMsg.remove();
  }, 3000);
}

function showCartError() {
  const errorMsg = document.createElement('div');
  errorMsg.innerHTML = '✗ Error adding to cart';
  errorMsg.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #dc3545;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 9999;
    font-weight: 600;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  `;
  
  document.body.appendChild(errorMsg);
  
  setTimeout(() => {
    errorMsg.remove();
  }, 3000);
}